import React from "react";
import { Modal, Row, Col, Alert } from "react-bootstrap";

const ViewCompletedCounsellorFeedback = ({ request, show, onClose }) => {
  const hasFeedback = request?.counsellorFeedback?.length > 0;

  return (
    <Modal className="border-0" show={show} onHide={onClose} centered>
      <Modal.Header className="border-0 mx-4 my-2" closeButton>
        {request?.counsellors?.map((item, index) => (
          <Modal.Title key={index} className="fs-6 d-flex align-items-center">
            <img
              src={`https://ui-avatars.com/api/?name=${item.firstName}+${item.lastName}&background=random&size=32`}
              className="rounded-circle me-2"
              alt="avatar"
              style={{ width: "40px", height: "40px" }}
            />
            <span className="my-auto">
              {item.firstName} {item.lastName}
            </span>
          </Modal.Title>
        ))}
      </Modal.Header>

      <Modal.Body className="mx-4">
        {hasFeedback ? (
          <Row className="gy-3">
            {request?.counsellorFeedback.map((item, index) => (
              <Col key={index} xs={12}>
                <div className="p-3 bg-light rounded">
                  <p className="mb-2" style={{ fontSize: "14px" }}>
                    {item.comments}
                  </p>
                  {/* Rating Stars */}
                  <div className="d-flex align-items-center">
                    <div className="d-flex me-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <svg
                          key={star}
                          className={`me-1 ${
                            item.rating >= star
                              ? "text-warning"
                              : "text-secondary"
                          }`}
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                        </svg>
                      ))}
                    </div>
                    <small className="text-muted">
                      {item.rating.toFixed(1)}
                    </small>
                  </div>

                  {/* Feedback Comment */}

                  {/* Feedback Date */}
                  {item.createdAt && (
                    <small className="text-muted d-block">
                      {new Date(item.createdAt).toLocaleString([], {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </small>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <Alert variant="info" className="text-center">
            No feedback available
          </Alert>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewCompletedCounsellorFeedback;
